import ActionTypes from "../constants/ActionTypes";

const initialState = {
    isSuccess: false,
    hasError: false,
    isLoading: false,
    contact: {}
};

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ActionTypes.CONTACT_FAILURE:
            return {
                ...state,
                hasError: true,
                isLoading: false
            };
        case ActionTypes.CONTACT_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case ActionTypes.ADD_CONTACT_SUCCESS:
            return {
                ...state,
                isSuccess: true,
                hasError: false,
                isLoading: false,
                contact: payload
            };
        case ActionTypes.GET_CONTACT_SUCCESS:
            return {
                ...state,
                isSuccess: true,
                hasError: false,
                isLoading: false,
                contact: payload
            };
        default:
            return state;
    }
};
